import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { BodyTextMedium } from '../../Typography/Typography';
import * as styles from './FormInputRadioGroupOption.module.scss';
export const FormInputRadioGroupOption = React.forwardRef((props, ref) => {
    return (_jsxs("label", { ref: ref, className: styles.container, children: [_jsx("input", { type: "radio", ...props, id: `${props.name}-option-${props.value}`, checked: props.selected, disabled: props.disabled }), _jsx(BodyTextMedium, { as: "span", children: props.label })] }));
});
